import { ComponentRecognizer } from '../../ComponentRecognizer/ComponentRecognizer';
import { registerComponents } from '../../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../../interfaces';
import type { FooterBlockImageType } from '../types';

type BlockImageProps = {
  data: FooterBlockImageType;
};

export const BlockImage = ({ data }: BlockImageProps) => (
  <div
    className="[&>.dangerously-html]:inline-flex [&>.dangerously-html]:w-auto [&>.dangerously-html]:shrink-0 [&>.dangerously-html]:content-center [&>.dangerously-html]:align-top"
    key={`block-image-${data.id}`}
  >
    {data.paragraph?.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ComponentRecognizer key={index} item={item} />
    ))}
  </div>
);

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.BlockImage]: BlockImage });
